import * as service from './services'
import to from 'await-to-js'

function b64ToUtf8 (str) {
  return decodeURIComponent(escape(window.atob(str)))
}
function parseJwt (token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(b64ToUtf8(base64))
}

export const state = {
  user: null,
  menuAdm: false
}

export const getters = {
  user: state => {
    if (state.user) {
      return state.user
    }
    let token = window.localStorage.getItem('user')

    if (!token) {
      return null
    }
    return parseJwt(token)
  },
  menuAdm: state => state.menuAdm
}

export const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setMenuAdm (state, payload) {
    state.menuAdm = payload
  }
}

export const actions = {
  setUser ({commit}, payload) {
    commit('setUser', payload)
  },
  setMenuAdm ({commit}, payload) {
    commit('setMenuAdm', payload)
  },
  async login ({dispatch}, credentials) {
    dispatch('setLoading', true)

    const [error = {response: {data: null}}, response = {data: null}] = await to(service.login(credentials))
    if (error) {
      console.log('Login error', error)
      dispatch('setLoading', false)
      return Promise.reject(error.response.data)
    }

    window.localStorage.setItem('user', window.JSON.stringify(response.data))
    dispatch('setUser', response.data)
    dispatch('loadDadosRede', response.data.rede)
    dispatch('setLoading', false)

    return response.data
  },

  logout ({dispatch}) {
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('rede')
    window.localStorage.removeItem('redeAdmin')
    dispatch('setUser')
    dispatch('setRede')
    dispatch('setRedeAdmin')
  },

  async loginCliente ({dispatch}, credentials) {
    dispatch('setLoading', true)
    const [error = {response: {data: null}}, response = {data: null}] = await to(service.loginCliente(credentials))
    if (error) {
      console.log('Login error', error)
      dispatch('setLoading', false)
      dispatch('showErrorMsg', error)
      return Promise.reject(error.response.data)
    }
    window.localStorage.setItem('user', window.JSON.stringify(response.data))
    dispatch('setUser', response.data)
    dispatch('setLoading', false)

    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js